import React from 'react';
import { PRICE } from './salesData';
interface PriceBlockProps {
  className?: string;
  size?: 'md' | 'lg';
}

/**
 * Único bloque de precio de la landing. Un solo precio vigente: no se muestra
 * precio anterior, descuento ni cuotas porque no existen datos reales.
 * Composición horizontal para que la card de compra se mantenga compacta.
 */
export function PriceBlock({
  className = '',
  size = 'md'
}: PriceBlockProps) {
  const current = size === 'lg' ? 'text-[3.4rem] sm:text-[4.2rem]' : 'text-[2.4rem] sm:text-[2.9rem]';
  const unit = size === 'lg' ? 'text-base sm:text-xl' : 'text-sm';
  return <div className={`flex flex-col items-center gap-3 sm:flex-row sm:items-center sm:justify-center sm:gap-6 ${className}`} data-id="element-223" data-mp="1twi78qra4xlr">
      <div className="flex items-start gap-2" data-id="element-224" data-mp="1p477pp0gbdtq">
        <span className={`mt-1.5 font-display leading-none text-caramel ${unit}`} data-id="element-225" data-mp="11ffm5ghd9tpx">
          {PRICE.currency}
        </span>
        <p className={`font-display leading-[0.86] tabular-nums text-charcoal ${current}`} data-id="element-226" data-mp="wftb9dp0gpka">
          {PRICE.current}
        </p>
      </div>

      <div className="text-center sm:max-w-[13rem] sm:border-l sm:border-warm sm:pl-6 sm:text-left" data-id="element-227" data-mp="1wyunv77lij4v">
        <p className="font-sans text-[0.62rem] font-bold uppercase tracking-editorial text-gold-deep" data-id="element-228" data-mp="21pt8uk3j45eg">
          Precio de lanzamiento
        </p>
        <p className="mt-1 font-sans text-[0.8rem] font-semibold leading-snug text-charcoal" data-id="element-229" data-mp="26ncptrrm2wa3">
          {PRICE.note}
        </p>
        <p className="mt-1 font-sans text-[0.72rem] leading-snug text-charcoal-mid" data-id="element-230" data-mp="193029l3gkbwj">{PRICE.fx}</p>
      </div>
    </div>;
}